import { 
  doc, 
  updateDoc,
  Timestamp,
  collection,
  addDoc
} from 'firebase/firestore';
import { ref, uploadBytesResumable, getDownloadURL } from '@firebase/storage';
import { v4 as uuidv4 } from 'uuid';
import { db, storage, auth } from './firebase';

// Ensure user is authenticated
function getUserId(): string {
  const user = auth.currentUser;
  if (!user) throw new Error('User must be authenticated');
  return user.uid;
}

export async function completeSession(
  sessionId: string,
  imageFile: File,
  comments: string,
  onProgress?: (progress: number) => void
): Promise<void> {
  const userId = getUserId();
  const sessionRef = doc(db, 'users', userId, 'bakingSessions', sessionId);

  try {
    // Upload image
    const imageFileName = `${uuidv4()}.jpg`;
    const imagePath = `users/${userId}/sessions/${sessionId}/original`;
    const imageRef = ref(storage, imagePath);

    const uploadTask = uploadBytesResumable(imageRef, imageFile);

    // Monitor upload progress
    uploadTask.on('state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (onProgress) onProgress(progress);
      },
      (error) => {
        throw error;
      }
    );

    // Wait for upload to complete
    await uploadTask;

    // Get download URL
    const imageUrl = await getDownloadURL(imageRef);

    // Update session document
    await updateDoc(sessionRef, {
      status: 'completed',
      result: {
        imageUrl,
        comments,
        completedAt: Timestamp.fromDate(new Date())
      }
    });

  } catch (error) {
    console.error('Error completing session:', error);
    throw error;
  }
}